import { axiosGetHandler, axiosPostHandler } from '../config';

// 获取游戏评论
export function getGameComments(args) {
  let url = '/bbs/app/link/game/comments';
  return axiosGetHandler(url, args);
}

/**
 * 黑盒快讯
 *
 */
export function getFlashNewsList(args) {
  let url = '/bbs/app/express_news';
  return axiosGetHandler(url, args);
}

/**
 * 征稿悬赏
 *
 */
// 获取页面数据
export function getContributionsPageData(args) {
  let url = '/bbs/app/award_mission/hashtag_mission';
  return axiosGetHandler(url, args);
}

// 发起用户验证
export function getUserVerify(args, formdata) {
  let url = '/bbs/app/award_mission/apply';
  return axiosPostHandler(url, args, formdata);
}

/**
 * 视频同步
 *
 */
// 获取所有平台信息
export function getPlatformList(args) {
  let url = '/bbs/app/author/external_sync/settings_data';
  return axiosGetHandler(url, args);
}

// 切换平台同步状态
export function updatePlatformStatus(args, formdata) {
  let url = '/bbs/app/author/external_sync/update';
  return axiosPostHandler(url, args, formdata);
}

// 获取平台视频信息
export function getVideoList(args) {
  let url = '/bbs/app/author/external_sync/home_data';
  return axiosGetHandler(url, args);
}

// 更新视频同步状态
export function updateVideoStatus(args, formdata) {
  let url = '/bbs/app/author/external_sync/update_history_status';
  return axiosPostHandler(url, args, formdata);
}

/**
 * 内容组2021年报
 *
 */
// 获取数据
export function getTwentyOneYearEndData(args) {
  let url = '/activity/heybox_2021/data';
  return axiosGetHandler(url, args);
}

// 获取用户信息
export function getTwentyOneYearEndUserData(args) {
  let url = '/activity/heybox_2021/front';
  return axiosGetHandler(url, args);
}

/**
 * 帖子分页
 *
 */
// 获取数据
export function getPostSharePageData(args) {
  let url = '/bbs/app/api/share/data/';
  return axiosGetHandler(url, args);
}
// 搜索游戏
export function searchGamesList(args) {
  var url = '/game/get_game_infos/';
  return axiosGetHandler(url, args);
}
// 搜索百科
export function searchWikiList(args) {
  var url = '/wiki/get_wiki_infos';
  return axiosGetHandler(url, args);
}
// 搜索sku商品
export function searchSkuList(args) {
  var url = '/mall/sku/detail/';
  return axiosGetHandler(url, args);
}
// 搜索游戏单
export function searchAlbumList(formdata) {
  let url = '/game/self_made_game_list/data/infos';
  return axiosPostHandler(url, {}, formdata);
}

/**
 * 概念版话题详情页工具页
 *
 */
export function getConceptTopicPageToolsList(args) {
  let url = '/bbs/app/topic/concept/tools/data';
  return axiosGetHandler(url, args);
}

/**
 * 概念版话题内容分享页
 *
 */
// 获取头部数据
export function getConceptTopicContentTabData(args) {
  let url = '/bbs/app/hashtag/menu';
  return axiosGetHandler(url, args);
}

// 获取列表数据
export function getConceptTopicContentListData(args) {
  let url = '/bbs/app/hashtag/concept/feeds';
  return axiosGetHandler(url, args);
}

/**
 * 概念版话题热点分享页
 *
 */
// 获取热点数据
export function getConceptTopicHotbData(args) {
  let url = '/bbs/app/hashtag/concept/feeds/news';
  return axiosGetHandler(url, args);
}

/**
 * 粉丝里程碑
 *
 */
// 获取里程碑数据
export function getFansMilestoneData(args) {
  let url = '/bbs/web/fans_milestone';
  return axiosGetHandler(url, args);
}
// 领取奖品
export function getFansMilestoneAward(formdata) {
  let url = '/bbs/web/get_decoration';
  return axiosPostHandler(url, {}, formdata);
}

/**
 * 创作盒TAB页
 *
 */
// 获取往期投稿块以及banner
export function getCreationTabPostBlockData(args) {
  let url = '/bbs/app/write_box/items';
  return axiosGetHandler(url, args);
}
// 获取推荐帖子数据
export function getCreationTabPostData(args) {
  let url = '/bbs/app/write_box/recommend';
  return axiosGetHandler(url, args);
}
